'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'light-switch';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e017';
var svgPathData = 'M32 32l320 0 0 448-320 0 0-448zM384 0L0 0 0 512 384 512 384 0zM128 384l0-112 128 0 0 112-128 0zm0-144l0-112 128 0 0 112-128 0zM96 96l0 320 192 0 0-320-192 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightSwitch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;